import { useMemo } from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { getCountryLabel } from '@razz-team/utils';

export interface AddressProps extends Omit<TypographyProps, 'children'> {
  country?: string | null;
  city?: string | null;
  zipCode?: string | null;
  region?: string | null;
  streetLine1?: string | null;
  streetLine2?: string | null;
  emoji?: boolean;
}

export function Address({
  country,
  city,
  zipCode,
  region,
  streetLine1,
  streetLine2,
  emoji = false,
  ...props
}: AddressProps) {
  // TODO: add locale support
  const children = useMemo(
    () =>
      [
        streetLine2,
        streetLine1,
        city,
        region,
        country ? getCountryLabel(country, { emoji }) : null,
        zipCode,
      ]
        .filter(Boolean)
        .join(', '),
    [streetLine2, streetLine1, city, region, country, zipCode, emoji],
  );

  return <Typography {...props}>{children}</Typography>;
}
